import { css } from '@emotion/react';
import { N20, N100, N700 } from '@atlaskit/theme/colors';
export const buttonGroupStyles = css({
  display: 'flex',
  alignItems: 'center',
  p: {
    marginRight: "var(--ds-space-050, 4px)"
  }
});
export const buttonStyles = isSelected => css({
  svg: {
    color: isSelected ? `var(--ds-icon-selected, ${N20})` : `var(--ds-icon-accent-gray, ${N100})`
  },
  '&[disabled]': {
    backgroundColor: isSelected ? `var(--ds-background-selected, ${N700})` : undefined
  }
});
export const dislikeButtonStyles = css({
  transform: 'rotate(180deg)'
});